export enum ScreenDevicesFamilyMinSize {
  // estos valores salen del diseño de figma
  sm = 440,
  md = 834,
  lg = 1440,
}
